import { getAnalytics, logEvent as firebaseLogEvent, setUserId } from 'firebase/analytics';
import { getFirebaseApp } from '../firebase';
// Function to set the user ID
/**
 *
 * @param userId
 * TODO: call this function in bootstrap to set user or deviceId
 */
export const setAnalyticsUserId = async (userId) => {
  // const firebaseApp = getFirebaseApp();
  // const analytics = getAnalytics(firebaseApp); // Initialize Analytics
  setUserId(analytics(), userId); // Set the user ID
};

export const logScreenView = (eventParams: { [key: string]: any }) => {
  // const analytics = getAnalytics();
  firebaseLogEvent(analytics(), 'screen_view', {
    firebase_screen: eventParams.screen_name,
    firebase_screen_class: eventParams.screen_class,
  });
};

export const logEvent = async (name: string, params?: { [key: string]: any }) => {
  try {
    // const analytics = getAnalytics();
    firebaseLogEvent(analytics(), name, {...params,debug_mode: true});
  } catch (error) {
    console.error(`Failed to log event: ${name}`, error);
  }
};

export const analytics = () => {
  const firebaseApp = getFirebaseApp();
  return getAnalytics(firebaseApp);
};
